module.exports = __webpack_public_path__ + "static/media/skyrock.36c067b8.png";